"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SpinPlaceholder = require("./SpinPlaceholder");
Object.keys(_SpinPlaceholder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SpinPlaceholder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SpinPlaceholder[key];
    }
  });
});